if (!customElements.get("vbb-wishlist-button")) {
  customElements.define(
    "vbb-wishlist-button",
    class WishlistButton extends HTMLElement {
      constructor() {
        super();

        this.productForm = this.closest('vbb-product-form') || this.closest('vbb-product-form-reactive');
        this.variantSelector = this.productForm?.querySelector('vbb-variant-selector-reactive') || this.productForm?.querySelector('vbb-product-card-variant-selector') || this.productForm?.querySelector('vbb-variant-selector');
        this.productFormId = this.productForm?.id;
        this.productId = this.dataset.productId;
        this.productUrl = this.dataset.productUrl;
        this.variantId = this.dataset.variantId;
        this.actionEl = this.querySelector('[data-action]');

        if (window.globalSwymWishlist.selectedListId) {
          this.init();
        } else {
          document.addEventListener('wishlist:fetch-lists:success', () => this.init());
        }

        this.actionEl.addEventListener('click', () => this.onActionElClick());

        if (this.productForm) {
          this.createMutationObserver(this.productForm);
        }

        if (this.variantSelector) {
          this.createMutationObserver(this.variantSelector);
        }

        document.addEventListener('variant:selected', (event) => {
          if (event.detail.productFormId == this.productFormId) {
            this.onVariantChange(event.detail.variantId);
          }
        });
      }

      init() {
        this.setIsWishlistedState();
      }

      setIsWishlistedState() {
        var isWishlisted = false;

        window.globalSwymWishlist.lists.forEach((list) => {
          list.listcontents?.forEach((item) => {
            if (item.empi == this.productId && item.epi == this.variantId) {
              isWishlisted = true;
            }
          });
        });

        this.classList[isWishlisted ? 'add' : 'remove']('is-wishlisted');
        this.classList.remove('is-disabled');
      }

      onActionElClick() {
        if (this.classList.contains('is-loading')) return;

        this.classList.add('is-loading');

        if (this.classList.contains('is-wishlisted')) {
          this.deleteFromWishlist();
        } else {
          this.addToWishlist();
        }
      }

      createMutationObserver(element) {
        var observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes') {
              this.onVariantChange(element.dataset.activeVariantId || element.dataset.activeVariant);
            }
          });
        });

        observer.observe(element, { attributes: true });
      }

      addToWishlist() {
        window.globalSwymWishlist.addToWishlist({
          productId: this.productId,
          productUrl: this.productUrl,
          variantId: this.variantId
        });

        document.addEventListener('wishlist:add-to-list:success', () => {
          this.classList.add('is-wishlisted');
          this.classList.remove('is-loading');
        }, { once: true });
      }

      deleteFromWishlist() {
        window.globalSwymWishlist.deleteFromWishlist({
          productId: this.productId,
          productUrl: this.productUrl,
          variantId: this.variantId
        });

        document.addEventListener('wishlist:delete-from-list:success', () => {
          this.classList.remove('is-wishlisted');
          this.classList.remove('is-loading');
        }, { once: true });
      }

      onVariantChange(variantId) {
        if (this.classList.contains('is-disabled')) return;

        this.dataset.variantId = this.variantId = variantId;
        this.setIsWishlistedState();
      }
    }
  );
}
